import getTagValue from '../../utilities/get-tag-value';

export default (details, tags = []) => {
    const coverUrl = getTagValue(tags, 'coverUrl', ':');
    if (coverUrl) return `https://${coverUrl}`;
    const regex = /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/i;
    const source = details || '';
    const foundImage = source.match(regex);
    const img = foundImage && foundImage[0] || '';
    return img;
};